<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="about-us" />

		<article class="gb-legal">
			<hh1>About GB Apps</hh1>
			<p>
				<a class="jump-url" href="https://gbappss.co/">gbappss.co</a>
				is a website focused on providing useful information, guides, and resources related to GB WhatsApp and
				Android applications.
			</p>
			<p>
				Our goal is to help users better understand GB WhatsApp features, installation steps, updates, old
				versions, and common issues they may encounter while using modified applications.
			</p>
			<p>On GB Apps, you can find:</p>
			<ul>
				<li>Latest GB WhatsApp version information</li>
				<li>APK download guides</li>
				<li>Installation and update tutorials</li>
				<li>Feature explanations</li>
				<li>Troubleshooting solutions</li>
				<li>Old version information</li>
				<li>Comparisons with official WhatsApp</li>
			</ul>
			<p>
				We create content based on common user questions and search needs, helping users find clear information
				before downloading or installing GB WhatsApp.
			</p>

			<hh2>Our Content Approach</hh2>
			<p>
				We focus on providing practical guides that are easy to follow. Whether you are installing GB WhatsApp
				for the first time, updating to a newer version, or looking for solutions to problems, our goal is to
				make the process easier.
			</p>
			<p>We regularly update our content with new version information, feature updates, and helpful tutorials.</p>

			<hh2>About GB WhatsApp</hh2>
			<p>
				GB WhatsApp is a third-party modified version of WhatsApp that includes additional customization and
				privacy options. It is not developed or officially supported by Meta.
			</p>
			<p>
				GB Apps is an independent information website and is not affiliated with WhatsApp, Meta, or any official
				WhatsApp service.
			</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'AboutUs',
	components: { HeadNav },
}
</script>
